module.exports = __webpack_public_path__ + "static/media/docPlanner1.50afbd58.PNG";